import {
  stateLabels,
  type RequestDetail,
} from "../../../../shared/labels/contracts";

export function LabelRecordHeader({
  detail,
  editorial = false,
}: {
  detail: RequestDetail;
  editorial?: boolean;
}) {
  if (editorial)
    return (
      <header className="anl-record-heading is-editorial">
        <div className="anl-editorial-record-top">
          <p className="anl-record-request-no">Talep no {detail.requestNo}</p>
          <div className="anl-record-state">
            <span className={"anl-status state-" + detail.state}>
              {stateLabels[detail.state]}
            </span>
          </div>
        </div>
        <div className="anl-record-identity">
          <h1>{detail.productName ?? "Etiket talebi"}</h1>
          <dl className="anl-record-facts">
            <div>
              <dt>Müşteri</dt>
              <dd>{detail.customerName ?? "—"}</dd>
            </div>
            <div>
              <dt>İş emri no</dt>
              <dd>{detail.workOrder ?? "—"}</dd>
            </div>
            <div>
              <dt>Üretim hattı</dt>
              <dd>{detail.lineName ?? "—"}</dd>
            </div>
            <div>
              <dt>Ürün kodu</dt>
              <dd>{detail.sku ?? detail.planRow?.sku ?? "—"}</dd>
            </div>
          </dl>
        </div>
      </header>
    );
  return (
    <header className="anl-record-heading">
      <div className="anl-record-identity">
        <h1>{detail.productName ?? "Etiket talebi"}</h1>
        <p>
          <strong>{detail.customerName ?? "Müşteri belirtilmemiş"}</strong>
          <span>İş emri {detail.workOrder ?? "—"}</span>
          {detail.lineName ? <span>{detail.lineName}</span> : null}
          <span>{detail.requestNo}</span>
        </p>
      </div>
      <div className="anl-record-state">
        <span className={"anl-status state-" + detail.state}>
          {stateLabels[detail.state]}
        </span>
      </div>
    </header>
  );
}
